import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

// ----------------------------------------------------------------------

RHFDatePicker.propTypes = {
  name: PropTypes.string,
  required: PropTypes.bool,
};

export default function RHFDatePicker({ name, required, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          {...field}
          renderInput={(params) => (
            <TextField {...params} fullWidth error={!!error} helperText={error?.message} required={required} />
          )}
          {...other}
        />
      )}
    />
  );
}
